import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import { base64logo, base64watermark } from "./BaseImages";

Font.register({
  family: "Roboto",
  fonts: [
    { src: "http://fonts.gstatic.com/s/roboto/v15/W5F8_SL0XFawnjxHGsZjJA.ttf" },
    {
      src: "http://fonts.gstatic.com/s/roboto/v15/bdHGHleUa-ndQCOrdpfxfw.ttf",
      fontStyle: "normal",
      fontWeight: 700,
    },
  ],
});

// Definir los estilos
const styles = StyleSheet.create({
  page: {
    fontSize: 12,
    color: "#454546",
    height: "100%",
  },
  header: {
    paddingHorizontal: 40,
    paddingTop: 40, // Reduce from 40 to 20
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingBottom: 40,
  }, 
  
  // Update the logo style
  logo: {
    width: "auto",
    height: 50, // Reduce from 64 to 50
  },
  
  // Update the headerright style
  headerright: {
    width: "auto",
    height: 45, // Reduce from 25% to 10%
  },
  
  // Update the title style
  title: {
    textAlign: "center",
    fontSize: 16,
    fontFamily: "Roboto",
    fontWeight: 700,
    color: "#000",
    marginBottom: 10, // Reduce from 20 to 10
  },
  section: {
    paddingHorizontal: 40,
    marginBottom: 10,
  },
  textBold: {
    color: "#000",
    fontSize: 12,
    fontFamily: "Roboto",
  },
  text: {
    marginBottom: 5,
    fontSize: 12,
    fontFamily: "Roboto",
  },
  footerImage: {
    width: "100%",
    height: "8%",
    position: "absolute",
    bottom: 0,
  },
  watermark: {
    position: "absolute",
    top: "35%",
    left: "15%",
    width: "70%",
    opacity: 0.04,
    zIndex: "-10",
  },
  gridContainer: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 50,
    marginBottom: 20,
  },
  gridItem: {
    width: "48%", // two items per row, with some space between
    marginBottom: 5,
  },
  singleItem: {
    width: "100%",
  },
  information: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 40,
    marginBottom: 10,
  },
  image:{
    width:100, 
    height:100
  },

   firmas: {
    marginTop: 40,
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: 20,
    position: "absolute",
    bottom: 20,
  },
  colum: {
    flex: 1,
    marginRight: 20,
    textAlign: "center",
    paddingTop: 80,
  },
  columDr: {
    flex: 1,
    textAlign: "center",
    marginLeft: 20,
  },
  firma: {
    width: "25%",
    marginLeft: "40%",
    height: "25%"
  },
});

const OrdenPdf = ({ data }) => {
  const orden = [];
  const archivos = data?.orden?.archivos;
  if (data.orden.tipo !== "Analisis de Gabinete")
    Object.keys(data.orden).forEach((key) => {
      if (
        data?.orden[key] &&
        !key.includes("resultado") &&
        !key.includes("_at") &&
        key !== "nombre" &&
        key !== "tipo" &&
        key !== "id" &&
        key !== "cita_id" &&
        key !== 'archivos' &&
        key !== 'archivo' &&
        key !== 'modulo_ubicacion'
      ) {
        orden.push(key.replaceAll("_", " ").toUpperCase());
      }
    });
  return (
    <Document>
      <Page style={styles.page}>
        <Image fixed style={styles.watermark} src="/images/watermark.jpg"/>
        {/* Header */}
        <View fixed style={styles.header}>
          <Image style={styles.logo} src="/images/logoderecho.jpg"/>
          <Image style={styles.headerright} src="/images/headerright.png" /> 
        </View>
        {/* Title */}
        <Text style={styles.title}>ORDEN DE ESTUDIO DE LABORATORIO</Text>
        {/* Patient Information */}
        <View style={styles.information}>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Nombre:</Text> {data?.nombre}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Edad:</Text> {data?.edad}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Lugar de atención:</Text>{" "}
              {data?.lugarAtencion}
            </Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Fecha:</Text> {data?.fecha}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Seguro:</Text> {data?.seguro}
            </Text>
            {data?.orden?.tipo && (
              <Text style={styles.text}>
                <Text style={styles.textBold}>Tipo:</Text> {data?.orden?.tipo}
              </Text>
            )}
          </View>
        </View>

        {/* Receta Details */}
        <View style={styles.section}>
          <Text style={styles.text}>
            <Text style={styles.textBold}></Text>
          </Text>

          {orden.length > 0 ? (
            orden.map((val, index) => (
              <View style={styles.section} key={val}>
                <Text style={styles.text}>{`${index + 1}). ${val}`}</Text>
              </View>
            ))
          ) : (
            <View style={styles.section}>
              <Text style={styles.text}>
                <Text style={styles.textBold}>Nombre:</Text>{" "}
                {data?.orden?.nombre}
              </Text>
              <Text style={styles.text}>
                <Text style={styles.textBold}>Descripción:</Text>{" "}
                {data?.orden?.descripcion}
              </Text>
            </View>
          )}
        </View>

        {/* Firmas */}
        <View style={styles.firmas}>
          <View style={styles.columDr}>
                  <Image style={styles.firma} src="/images/firma.png"/>
                  <Text style={styles.text}>______________________</Text>
              <Text style={styles.text}>{ process.env.REACT_APP_NOMBRE_DOC }</Text>
              <Text style={styles.text}>Odontologa Ortodoncista</Text>
          </View>
        </View>

        {/* Footer*/}
        {/* <Image style={styles.footerImage} src="/images/png" /> */}
      </Page>
    </Document>
  );
};

export default OrdenPdf;